<div class="pkt-form-field" [class.pkt-error-state]="!!errorMessage" [class.pkt-disabled]="disabled">
  <label *ngIf="label" class="pkt-label" [class.pkt-label--clamp]="labelLines" [style.--pkt-label-lines]="labelLines">
    {{ label }}<span *ngIf="required" class="pkt-required">*</span>
  </label>

  <div class="pkt-input-wrapper has-suffix">
    <input class="pkt-input" [matDatepicker]="picker" [matDatepickerFilter]="dateFilter" [placeholder]="placeholder"
      [disabled]="disabled" [min]="minDate" [max]="maxDate" [value]="value" (dateChange)="onDateChange($event)"
      (click)="!disabled && picker.open()" [style.cursor]="disabled ? 'default' : 'pointer'" readonly />
    <mat-datepicker #picker [startAt]="startAt" panelClass="pkt-calendar"></mat-datepicker>

    <button class="pkt-suffix-icon-btn" type="button" (click)="picker.open()" [disabled]="disabled" tabindex="-1">
      <span class="material-symbols-outlined">calendar_month</span>
    </button>
  </div>

  <div *ngIf="hint && !errorMessage" class="pkt-hint">{{ hint }}</div>
  <div *ngIf="errorMessage" class="pkt-error-msg">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
</div>